import { createSelector } from 'reselect'

const selectBrokerCoverage = state => state.broker_coverage || {}
export const selectBrokerCoverageGeoJson = createSelector(selectBrokerCoverage, coverage => coverage.geo_json || null)
export const selectBrokerCoverageLoading = createSelector(selectBrokerCoverage, coverage => coverage.loading || false)
